<template>
  <div class="wl-container">
    <div class="wl-content-container">
      <div class="wl-info">
        <el-row :gutter="35">
          <el-col :span="12">{{$t('site007')}}</el-col>
          <el-col :span="12">
            <div class="column-btn" @click="setClick">
              <img src="@/assets/img/icon-setting.svg" width="100%" class="table-setting-icon" />
              <span>Adjust The Alert Settings</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row class="search-row">
        <div class="el-col-12 el-row--flex">
          <el-date-picker
            class="wl-item wl-date-item2 input-with-select margin"
            v-model="value1"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('begin_date')"
            :end-placeholder="$t('end_date')">
          </el-date-picker>
          <el-button
            icon="el-icon-search"
            @click="searchBtnClick"
            class="wl-green"
          >{{$t('btn_search2')}}
          </el-button>
          <el-button
            @click="clearAll"
            class="cancel-btn"
          >{{$t('COMMON_CLEAR_BTN')}}
          </el-button>
        </div>
        <div class="el-col-12">
          <el-button
            @click="searchBtnClick"
            class="wl-green right"
          >
            <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon"  alt=""/>
            {{$t('BATCH_export')}}
          </el-button>
        </div>
      </el-row>
      <div class="table-container-wrapper">
        <el-table
          height="100%"
          :data="tableData"
          v-loading="tableLoading"
          stripe
          border
        >
          <el-table-column label="No." prop="no" header-align="center" align="center" width="60"></el-table-column>
          <el-table-column label="Downloaded by" prop="downloadBy" header-align="center" align="left">
            <template  #header>
              <!-- 表头标题 -->
              <div class="th-label">{{ $t('table_column_downloaded_by') }}<multi-select-popover/></div>
            </template>
          </el-table-column>
          <el-table-column label="E-mail address" prop="email" header-align="center" align="left">
            <template  #header>
              <!-- 表头标题 -->
              <div class="th-label">{{ $t('email_address') }}<multi-select-popover/></div>
            </template>
          </el-table-column>
          <el-table-column label="Confirmation" prop="confirmation" header-align="center">
            <el-table-column label="PCS" prop="confirmationPcs" header-align="center" align="right" sortable/>
            <el-table-column label="Size" prop="confirmationSize" header-align="center" align="right" sortable/>
          </el-table-column>
          <el-table-column label="Joint Working" prop="jointWorking" header-align="center" align="center">
            <el-table-column label="PCS" prop="jointWorkingPcs" header-align="center" align="right" sortable/>
            <el-table-column label="Size" prop="jointWorkingSize" header-align="center" align="right" sortable/>
          </el-table-column>
          <el-table-column label="PBC" prop="PBC" header-align="center">
            <el-table-column label="PCS" prop="PbcPcs" header-align="center" align="right" sortable/>
            <el-table-column label="Size" prop="PbcSize" header-align="center" align="right" sortable/>
          </el-table-column>
          <el-table-column label="Statutory" prop="statutory" header-align="center">
            <el-table-column label="PCS" prop="statutoryPcs" header-align="center" align="right" sortable/>
            <el-table-column label="Size" prop="statutorySize" header-align="center" align="right" sortable/>
          </el-table-column>
          <el-table-column label="Total Downloaded Files" prop="totalDownloadedFiles" header-align="center">
            <el-table-column label="PCS" prop="totalDownloadedFilesPcs" header-align="center" align="right" sortable>
              <template slot-scope="scope">
                <span class="underline-content waring" @click="showDownloadFileClick">
                    {{scope.row.totalDownloadedFilesPcs}}
                  </span>
              </template>
            </el-table-column>
            <el-table-column label="Size" prop="totalDownloadedFilesSize" header-align="center" align="right" sortable>
              <template slot-scope="scope">
                <div class="underline-content">
                  {{scope.row.totalDownloadedFilesSize}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="Adjust The Alert Settings"
      width="400px"
      :visible.sync="setVisible"
      @close="setVisible = false"
    >
      <el-form ref="setForm" :model="setForm" label-position="top">
        <el-form-item label="Total Download Files In Past One Weed(pcs)" class="bottom-line">
          <el-input-number v-model="setForm.pcs" :min="1" :max="10" label="描述文字"/> PCS
        </el-form-item>
        <el-form-item label="Total Download Files In Past One Weed(size)" class="bottom-line">
          <el-input-number v-model="setForm.pcs" :min="1" :max="10" label="描述文字"/> MB
        </el-form-item>
        <el-form-item label="Alert the engagement manager when the client downloaded files exceeds the risk value set above">
          <el-switch
            v-model="setForm.switch"
            class="switch-width-cls"
            active-color="#409EFF"
            inactive-color="#cccccc"
          >
          </el-switch>
          Send email alert
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button class="wl-gray" :loading="dialogLoading" @click="cancelClick">{{$t('btn_cancel')}}</el-button>
          <el-button class="wl-green" :loading="dialogLoading" @click="saveClick">{{$t('btn_confirm')}}</el-button>
      </span>
    </el-dialog>
    <download-file-dialog :showDownloadVis="showDownloadVis" @close="showDownloadVis = false" />
  </div>
</template>
<script>
  import DownloadFileDialog from "./components/downloadFileDialog";
  import MultiSelectPopover from "@/components/common/MultiSelectPopver";
  export default {
    name: "index",
    components: {MultiSelectPopover, DownloadFileDialog},
    data() {
      return {
        value1: [],
        tableData: [
          {
            no: 1,
            downloadBy: "client 1",
            email: "test@client.com",
            confirmationPcs: 4,
            confirmationSize: "23M",
            jointWorkingPcs: 3,
            jointWorkingSize: 44,
            PbcPcs: 4,
            PbcSize: 14,
            statutoryPcs: 33,
            statutorySize: 56,
            totalDownloadedFilesPcs: 123,
            totalDownloadedFilesSize: "23M",
          },
          {
            no: 2,
            downloadBy: "client 1",
            email: "test@client.com",
            confirmationPcs: 4,
            confirmationSize: "23G",
            jointWorkingPcs: 3,
            jointWorkingSize: 44,
            PbcPcs: 4,
            PbcSize: 14,
            statutoryPcs: 33,
            statutorySize: 56,
            totalDownloadedFilesPcs: 123,
            totalDownloadedFilesSize: 3,
          },
          {
            no: 3,
            downloadBy: "client 1",
            email: "test@client.com",
            confirmationPcs: 4,
            confirmationSize: 23,
            jointWorkingPcs: 3,
            jointWorkingSize: 44,
            PbcPcs: 4,
            PbcSize: 14,
            statutoryPcs: 33,
            statutorySize: 56,
            totalDownloadedFilesPcs: 123,
            totalDownloadedFilesSize: 3,
          },
          {
            no: 4,
            downloadBy: "client 1",
            email: "test@client.com",
            confirmationPcs: 4,
            confirmationSize: 23,
            jointWorkingPcs: 3,
            jointWorkingSize: 44,
            PbcPcs: 4,
            PbcSize: 14,
            statutoryPcs: 33,
            statutorySize: 56,
            totalDownloadedFilesPcs: 123,
            totalDownloadedFilesSize: 3,
          }
        ],
        tableLoading: false,
        setVisible: false,
        setForm: {},
        dialogLoading: false,
        showDownloadVis: false,
        sumText: "All Files In This KCC Site"
      }
    },
    mounted() {
    },
    methods: {
      searchBtnClick() {},
      clearAll() {},
      setClick() {
        this.setVisible = true;
      },
      cancelClick() {
        this.setVisible = false;
      },
      saveClick() {
        this.setVisible = false;
      },
      showDownloadFileClick() {
        this.showDownloadVis = true
      },
    }
  }
</script>
<style scoped>
  .wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
  }

  .wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
    border-radius: 8px;
  }

  .wl-info {
    width: 100%;
    border-bottom: 1PX solid #e3e4e6;
    height: 33PX;
    line-height: 33PX;
    font-size: 14PX;
  }
  .search-row {
    padding: 15px 0;
  }
  .wl-date-item2{
    width: 370PX !important;
  }
  .margin {
    margin-right: 10px;
  }
  .right {
    float: right;
  }
  .table-container-wrapper {
    height: calc(100% - 63PX - 30px);
  }
  .column-btn {
    font-size: 12PX;
    display: flex;
    float: right;
  }
  .column-btn .table-setting-icon{
    width: 20px;
    margin-right: 5px;
  }
  .column-btn:hover {
    color: rgb(0, 94, 184)
  }
  ::v-deep .el-form {
    padding: 5PX
  }
  .bottom-line {
    border-bottom: 1PX dashed #e3e4e6;
    padding-bottom: 20px;
  }
  .underline-content {
    text-decoration: underline;
    color:#3879eb;
    padding: 5px;
    border-radius: 7px;
  }
  .waring {
    background-color: #f2b000;
    color: white;
  }
  .th-label {
    display: flex;
    flex-direction: row;
  }
</style>
